import FilterHotelName from './FilterHotelName';

export default FilterHotelName;
